module.exports = __webpack_public_path__ + "fonts/GothamSSm-Light.3862245b.woff";